import React, { useEffect, useState } from "react";

import FeaturedSettings from "../FeaturedSettings";

import { useAppSelector } from "../../../../redux/hooks";
import { getAuthToken } from "../../../../redux/reducers/auth";

import { RequestState } from "../../../../utils/RequestState";
import {
  useGetTeams,
  useGetPickupTeams,
  useUpdateFeaturedTeams,
} from "../../../../utils/useTeam";

const FeaturedTeamSettingsContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  // Pickup
  const [featuredTeamsList, setFeaturedTeamsList] = useState<
    Array<{ id: string; name: string; status: string }>
  >([]);
  const [teamsTitle, setTeamsTitle] = useState<string>("");

  const {
    title: featuredTeamsTitle,
    entries: featuredTeams,
    isLoading,
  } = useGetPickupTeams();

  const { mutateAsync, mutateLoading } = useUpdateFeaturedTeams();

  useEffect(() => {
    if (isLoading) return;

    const fTeams: Array<{ id: string; name: string; status: string }> = [];
    for (const fTeam of featuredTeams) {
      fTeams.push({ id: fTeam.id, name: fTeam.name, status: fTeam.status });
    }

    setFeaturedTeamsList([...fTeams]);
    setTeamsTitle(featuredTeamsTitle);
  }, [isLoading]);

  // Team
  const {
    items: { teams },
    isLoading: teamLoading,
  } = useGetTeams({ per: -1 });
  const [teamNameList, setTeamNameList] = useState<Array<string>>([]);

  useEffect(() => {
    if (teamLoading) return;
    const tNames: Array<string> = [];

    for (const team of teams) {
      tNames.push(team.name);
    }

    setTeamNameList([...tNames]);
  }, [teamLoading]);

  // Handler
  const handleChange = (index: number, value: string) => {
    const team = teams.find(({ name }) => name == value);
    if (team) {
      if (featuredTeamsList.find(({ id }) => id == team.id)) {
        //TODO: Show error
      }

      const newTeam = { id: team.id, name: team.name, status: team.status };

      const fTeams = featuredTeamsList;
      fTeams[index] = newTeam;
      setFeaturedTeamsList([...fTeams]);
      setRequestState(RequestState.Pending);
    } else {
      const newTeam = { id: "", name: value, status: "" };

      const fTeams = featuredTeamsList;
      fTeams[index] = newTeam;
      setFeaturedTeamsList([...fTeams]);
      setRequestState(RequestState.Pending);
    }
    return false;
  };

  const handleTitle = (value: string) => {
    setTeamsTitle(value);
    setRequestState(RequestState.Pending);
  };

  const addItem = () => {
    const fTeams = featuredTeamsList;

    fTeams.push({ id: "", name: "", status: "" });
    setFeaturedTeamsList([...fTeams]);
  };

  const removeItem = (index: number) => {
    const fTeams = featuredTeamsList;

    fTeams.splice(index, 1);
    setFeaturedTeamsList([...fTeams]);
  };

  const handleSubmit = async () => {
    if (auth_token) {
      setRequestState(RequestState.Doing);

      const ids: Array<string> = [];
      const fTeams = featuredTeamsList;

      for (const fTeam of fTeams) {
        ids.push(fTeam.id);
      }

      await mutateAsync({
        auth_token: auth_token,
        ids: ids,
        title: teamsTitle,
      });
      setRequestState(RequestState.Success);
    }
  };

  return (
    <FeaturedSettings
      target="チーム"
      name="team"
      id="Teams"
      isLoading={isLoading || mutateLoading}
      options={teamNameList}
      selectedItems={featuredTeamsList}
      featuredTitle={teamsTitle}
      requestState={requestState}
      addItem={addItem}
      removeItem={removeItem}
      handleChange={handleChange}
      handleTitle={handleTitle}
      handleSubmit={handleSubmit}
    />
  );
};

export default FeaturedTeamSettingsContainer;
